import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useInfiniteListQuery as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperRequestLogQuery.ts
var i = 50, a = 1e4, o = (o, s = {}) => {
	let c = n(), l = e.requestLog(o), u = t({
		queryKey: l,
		fetchPage: (e) => r.requests({
			...o,
			page: e,
			pageSize: i
		}),
		key: "items",
		enabled: s.enabled ?? !0,
		refetchInterval: (e) => s.live && (e.state.data?.pages.length ?? 0) <= 1 ? a : !1,
		refetchIntervalInBackground: !1
	}), d = () => c.resetQueries({
		queryKey: l,
		exact: !0
	});
	return {
		...u,
		resetToNewest: d
	};
};
//#endregion
export { o as useWorkspaceDeveloperRequestLogQuery };
